import { useSignalRWebRTC } from "@/components/common/connection/useSignalRWebRTC";
import UserLobbyPage from "./UserLobbyPage";
import VideoCallUI from "./VideoCallScreen";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setConnectionStatus,
  setLocalMicOn,
  setLocalVideoOn,
  setSelectedMic,
  setSelectedCamera,
  setLocalStream,
} from "@/store/slices/callSlice";
import type { RootState } from "@/store";
// import { Video } from "lucide-react";
// import { showCallStartedNotification } from "@/components/common/showWindowNotification";

function ReconnectionPage({ connectionStatus }: { connectionStatus: string }) {
  return (
    // <div className="flex items-center justify-center h-screen w-full bg-gradient-to-br from-blue-600 to-indigo-700">
    //   <div className="flex flex-col items-center gap-6">
    //     <div className="relative">
    //       <div className="absolute inset-0 rounded-full bg-blue-400 opacity-40 animate-ping"></div>
    //       <div className="absolute inset-0 rounded-full bg-blue-300 opacity-30 animate-pulse"></div>
    //       <div className="relative flex items-center justify-center h-24 w-24 rounded-full bg-white shadow-lg">
    //         <Video className="h-12 w-12 text-blue-600 animate-bounce" />
    //       </div>
    //     </div>

    //     <div className="flex flex-col items-center">
    //       <p className="text-2xl font-semibold text-white animate-pulse">
    //         {connectionStatus === "reconnecting"
    //           ? "Reconnecting to your call..."
    //           : "Connecting to call..."}
    //       </p>
    //       <p className="text-sm text-gray-200 mt-2 animate-fade">
    //         Please wait while we restore your connection
    //       </p>
    //     </div>
    //   </div>
    // </div>
    <div className="h-screen w-full flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a]">
      {/* Animated gradient orbs */}
      <div className="absolute w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse -top-10 -left-10"></div>
      <div className="absolute w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl animate-pulse -bottom-20 -right-20"></div>

      {/* Loader content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Animated Video Call Icon */}
        <div className="relative">
          <div className="absolute inset-0 bg-blue-500/40 rounded-full blur-xl animate-ping"></div>

          <div className="h-24 w-24 rounded-full bg-white/10 backdrop-blur-xl flex items-center justify-center border border-white/20 shadow-xl">
            <svg
              className="w-12 h-12 text-blue-400 animate-bounce"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
            >
              <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 7h8a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z" />
            </svg>
          </div>
        </div>

        {/* Text Section */}
        <h2 className="mt-6 text-2xl font-semibold text-white animate-pulse tracking-wide">
          {connectionStatus === "reconnecting"
            ? "Reconnecting to your call..."
            : "Connecting to call..."}
        </h2>
        <p className="text-gray-300 text-sm mt-2">
          Please wait while we restore your connection
        </p>
      </div>
    </div>
  );
}
function ConnectingPage({ connectionStatus }: { connectionStatus: string }) {
  return (
    // <div className="flex items-center justify-center h-screen w-full bg-gradient-to-br from-blue-600 to-indigo-700">
    //   <div className="flex flex-col items-center gap-6">
    //     <div className="relative">
    //       <div className="absolute inset-0 rounded-full bg-blue-400 opacity-40 animate-ping"></div>
    //       <div className="absolute inset-0 rounded-full bg-blue-300 opacity-30 animate-pulse"></div>
    //       <div className="relative flex items-center justify-center h-24 w-24 rounded-full bg-white shadow-lg">
    //         <Video className="h-12 w-12 text-blue-600 animate-bounce" />
    //       </div>
    //     </div>

    //     <div className="flex flex-col items-center">
    //       <p className="text-2xl font-semibold text-white animate-pulse">
    //         {connectionStatus === "reconnecting"
    //           ? "Reconnecting to your call..."
    //           : "Connecting to call..."}
    //       </p>
    //       <p className="text-sm text-gray-200 mt-2 animate-fade">
    //         Please wait while we restore your connection
    //       </p>
    //     </div>
    //   </div>
    // </div>
    <div className="h-screen w-full flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a]">
      {/* Animated gradient orbs */}
      <div className="absolute w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse -top-10 -left-10"></div>
      <div className="absolute w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl animate-pulse -bottom-20 -right-20"></div>

      {/* Loader content */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Animated Video Call Icon */}
        <div className="relative">
          <div className="absolute inset-0 bg-blue-500/40 rounded-full blur-xl animate-ping"></div>

          <div className="h-24 w-24 rounded-full bg-white/10 backdrop-blur-xl flex items-center justify-center border border-white/20 shadow-xl">
            <svg
              className="w-12 h-12 text-blue-400 animate-bounce"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
            >
              <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 7h8a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z" />
            </svg>
          </div>
        </div>

        {/* Text Section */}
        <h2 className="mt-6 text-2xl font-semibold text-white animate-pulse tracking-wide">
          {connectionStatus === "reconnecting"
            ? "Reconnecting to your call..."
            : "Network issue ReConnecting to call..."}
        </h2>
        <p className="text-gray-300 text-sm mt-2">
          Please wait Agnet is online restore your connection
        </p>
      </div>
    </div>
  );
}

export default function ConnectionPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const socketURL = window.VITE_SOCKET_URL || null;

  // --- Redux State ---
  const localStream = useSelector((state: RootState) => state.call.localStream);
  const peers = useSelector((state: RootState) => state.call.peers);
  const connectionStatus = useSelector(
    (state: RootState) => state.call.connectionStatus
  );
  const isCallActive = useSelector(
    (state: RootState) => state.call.isCallActive
  );
  const userId = useSelector((state: RootState) => state.call.userId);
  const localMicOn = useSelector((state: RootState) => state.call.localMicOn);
  const localVideoOn = useSelector(
    (state: RootState) => state.call.localVideoOn
  );
  const screenShareActive = useSelector(
    (state: RootState) => state.call.screenShareActive
  );
  const activeSpeakerInfo = useSelector(
    (state: RootState) => state.call.activeSpeakerInfo
  );
  const activeSpeakerStream = useSelector(
    (state: RootState) => state.call.activeSpeakerStream
  );
  const selectedMic = useSelector((state: RootState) => state.call.selectedMic);
  const selectedCamera = useSelector(
    (state: RootState) => state.call.selectedCamera
  );
  // const isTokenAcquired = useSelector((state: RootState) => state.call.isTokenAcquired);

  // --- Chat Message Callback ---
  const chatMessageReceivedCallbackRef = useRef<(() => void) | null>(null);
  const setChatMessageReceivedCallback = useCallback((callback: () => void) => {
    chatMessageReceivedCallbackRef.current = callback;
  }, []);
  const handleNewChatMessageFromRTC = useCallback(() => {
    if (chatMessageReceivedCallbackRef.current) {
      chatMessageReceivedCallbackRef.current();
    }
  }, []);

  // --- WebRTC Hook ---
  const {
    connect,
    disconnect,
    // sendMessage,
    toggleLocalMic,
    toggleLocalVideo,
    toggleScreenShare,
    handleDeviceChange,
    handleFacingModeChange,
    sendRtcChatMessage,
    sendRtcDataMessage,
    // areStreamsReady,
    InteractionData,
    EstimedWaitTime,
    // abortSignalRConnection,
  } = useSignalRWebRTC(socketURL, navigate, handleNewChatMessageFromRTC);

  // --- Block Access if User Not Allowed ---
  useEffect(() => {
    const isAllowed = localStorage.getItem("videoCallAllowed");
    if (isAllowed !== "true") {
      navigate("/");
    }
  }, [navigate]);

  // --- Restore Mic/Camera Preferences ---
  useEffect(() => {
    const session = localStorage.getItem("callSession");
    if (session) {
      try {
        const parsed = JSON.parse(session);
        if (parsed.isCallActive) {
          dispatch(setConnectionStatus("reconnecting"));
        }
        if (typeof parsed.localMicOn === "boolean") {
          dispatch(setLocalMicOn(parsed.localMicOn));
        }
        if (typeof parsed.localVideoOn === "boolean") {
          dispatch(setLocalVideoOn(parsed.localVideoOn));
        }
        if (parsed.selectedMic) {
          dispatch(setSelectedMic(parsed.selectedMic));
        }
        if (parsed.selectedCamera) {
          dispatch(setSelectedCamera(parsed.selectedCamera));
        }
      } catch (err) {
        console.error("Failed to parse callSession:", err);
      }
    }
    return () => {
      dispatch(setConnectionStatus("disconnected"));
      localStorage.clear();
    };
  }, [dispatch]);

  // --- Create Local Stream for Call (Separate from Lobby) ---
  useEffect(() => {
    if (!isCallActive || localStream) return;

    const initLocalStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true,
        });

        // Apply initial mic/camera states from Redux
        stream
          .getAudioTracks()
          .forEach((track) => (track.enabled = localMicOn));
        stream
          .getVideoTracks()
          .forEach((track) => (track.enabled = localVideoOn));

        dispatch(setLocalStream(stream));
      } catch (error) {
        console.error("Failed to get local media stream:", error);
      }
    };

    initLocalStream();
  }, [isCallActive, localMicOn, localVideoOn, localStream, dispatch]);

  // --- Keep Local Stream Tracks in Sync ---
  useEffect(() => {
    if (!localStream) return;

    localStream.getAudioTracks().forEach((track) => {
      track.enabled = localMicOn;
    });
    localStream.getVideoTracks().forEach((track) => {
      track.enabled = localVideoOn;
    });
  }, [localStream, localMicOn, localVideoOn]);

useEffect(() => {
  const joinViaLink = localStorage.getItem("joinViaLink") === "true";
  const roomId = localStorage.getItem("RoomId");

  // Try to get username safely
  const customerConnect = localStorage.getItem("customerConnect");
  let userName = "Guest";

  if (customerConnect) {
    try {
      const parsed = JSON.parse(customerConnect);
      userName =
        parsed?.userdata?.FirstName ||
        parsed?.values?.first_name ||
        "Guest";
    } catch (e) {
      console.error("Failed to parse customerConnect", e);
    }
  }

  if (
    joinViaLink &&
    roomId &&
    connectionStatus === "disconnected"
  ) {
    console.log("🔁 Auto-joining room via link...", {
      roomId,
      userName,
    });

    // ✅ PASS REQUIRED ARGUMENTS
    connect(roomId, userName);

    // localStorage.removeItem("joinViaLink");
  }
}, [connectionStatus, connect]);

  // --- Navigate to Feedback if Call Ends ---
  useEffect(() => {
    if (
      !isCallActive &&
      (connectionStatus === "disconnected" || connectionStatus === "failed") &&
      window.location.pathname === "/videoCall"
    ) {
      navigate("/UserFeedback");
    }
  }, [isCallActive, connectionStatus, navigate]);

  // --- UI Rendering ---
  if (connectionStatus === "reconnecting") {
    return <ReconnectionPage connectionStatus={connectionStatus} />;
  }
    if (connectionStatus === "ActiveConnecting") {
    return <ConnectingPage connectionStatus={connectionStatus} />;
  }

  if (isCallActive) {
    return (
      <VideoCallUI
        localStream={localStream}
        peers={peers}
        userId={userId}
        disconnect={disconnect}
        toggleLocalMic={toggleLocalMic}
        toggleLocalVideo={toggleLocalVideo}
        toggleScreenShare={toggleScreenShare}
        localMicOn={localMicOn}
        localVideoOn={localVideoOn}
        screenShareActive={screenShareActive}
        activeSpeakerInfo={activeSpeakerInfo}
        activeSpeakerStream={activeSpeakerStream}
        handleDeviceChange={handleDeviceChange}
        handleFacingModeChange={handleFacingModeChange}
        selectedMic={selectedMic}
        selectedCamera={selectedCamera}
        setChatMessageReceivedCallback={setChatMessageReceivedCallback}
        sendRtcChatMessage={sendRtcChatMessage}
        sendRtcDataMessage={sendRtcDataMessage}
      />
    );
  }

  return (
    <UserLobbyPage
      connect={connect}
      connectionStatus={connectionStatus}
      isWaitingForAgent={connectionStatus === "connecting"}
      InteractionData={InteractionData}
      EstimedWaitTime={EstimedWaitTime}
      // abortSignalRConnection={abortSignalRConnection}
    />
  );
}
